import React from 'react'
import { Component } from 'reflux'
import { toast } from 'react-toastify'
import AnnouncementForm from 'Modules/announcement/announcementForm'
import { clearToast } from 'Reducers/announcementReducer'
import { STATUS, getAnnouncementDetails, getBrands } from 'Reducers/actions/announcementActions'
import { connect } from 'react-redux'

class AnnouncementEdit extends Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {
    this.props.getAnnouncementDetails(this.props.match.params.AnnouncementID)
    this.props.getBrands()
  }
  componentDidUpdate() {
    if (this.props.loadingState === STATUS.FETCHING_ANNOUNCEMENT_DETAILS_FAILED) {
      toast.error('FETCHING ANNOUNCEMENT FAILED', {
        autoClose: 7500,
        onClose: () => {
          this.props.clearToast()
        }
      })
      this.props.clearToast()
    }

    if (this.props.loadingState === STATUS.ANNOUNCEMENT_FAILED) {
      toast.error('UPDATE ANNOUNCEMENT FAILED', {
        autoClose: 3000,
        onClose: () => {
          this.props.clearToast()
        }
      })
      this.props.clearToast()
    }
    if (this.props.loadingState === STATUS.ANNOUNCEMENT_SUCCESS) {
      toast.success('UPDATE ANNOUNCEMENT SUCCESSFUL', {
        autoClose: 3000,
        onClose: () => {
          this.props.clearToast()
        }
      })
      this.props.clearToast(STATUS.IS_REDIRECT)
    }
  }

  render() {
    return (
      <React.Fragment>
        <AnnouncementForm {...this.props} />
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({ loadingState: state.announcement.loadingState })

export default connect(mapStateToProps, { getAnnouncementDetails, clearToast, getBrands })(AnnouncementEdit)
